export default __webpack_public_path__ + "static/comparisons-app-creation--mobile-783fc5d7d011ae4493a3a0cf11428be4.webp";